<template>
	<div>
		<div class="conBox animate__animated animate__fadeIn" data-wow-duration="0.8s">
		<div class="pageTit">
			<span>订单管理</span>
		</div>
		<!-- 筛选 -->
		<div class="shaixuan">
			<div class="catBox">
				<div class="cat flex" style="flex-wrap: nowrap;margin-bottom: 0.1rem;">
					<div class="tit" style="padding-top: 0.04rem;">方向:</div>
					<div class="f-ct" style="width: calc(100% - 1rem);">
						<div class="itm" style="margin-bottom: 0.1rem;" @click="selCat(itm)" :class="catIdx==itm.id?'a':''" v-for="(itm,idx) in catArr">{{itm.categoryName}}</div>
					</div>
				</div>
				<div class="cat flex" style="flex-wrap: nowrap;margin-bottom: 0rem;">
					<div class="tit" style="padding-top: 0.04rem;">分类:</div>
					<div class="f-ct" style="width: calc(100% - 1rem);">
						<div class="itm" style="margin-bottom: 0.1rem;" @click="selCat1(itm.id)" :class="catIdx1==itm.id?'a':''" v-for="(itm,idx) in catArr1">{{itm.categoryName}}</div>
					</div>
				</div>
			</div>
			<div class="seach f-ct">
				<div class="iptBox f-ct">
					<div class="sel">
						<el-select v-model="payStatusValue" placeholder="请选择">
							<el-option
								v-for="item in payStatusOptions"
								:key="item.value"
								:label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
					</div>
					<div class="bor"></div>
					<div class="ipt">
						<el-input type="text" v-model="keyword" placeholder="请输入搜索关键词"></el-input>
					</div>
				</div>
				<div class="seachBtn f-ct">
					<div @click="courseOrderlist(1)">搜索</div>
					<div @click="keyword='',payStatusValue='-1',courseOrderlist(1)">重置</div>
				</div>
			</div>
		</div>
		<!-- 订单列表 -->
		<div class="zw" v-if="!orderList.length">
			<el-image :src="require('@/static/zw.png')"></el-image>
			<p>暂无相关数据...</p>
		</div>
		<div class="orderList">
			<div class="item" v-for="(item,index) in orderList">
				<div class="osn f-bct">
					<div class="sn">订单编号：{{item.orderNo}}</div>
					<div class="status s1" v-if="item.payStatus==0">待缴费</div>
					<div class="status s3" v-if="item.payStatus==1">已支付</div>
					<div class="status s4" v-if="item.payStatus==2">已取消</div>
				</div>
				<div class="msg f-bct">
					<div class="l">
						<div class="name">{{item.courseName}}</div>
						<div class="tagBox f-ct">
							<div class="tagItm">{{item.courseCategoryName}}</div>
						</div>
					</div>
					<div class="r" v-if="item.payStatus==0">
						待付 <span>￥{{item.totalPrice}}</span>
					</div>
				</div>
				<div class="time f-bct">
					<div class="l f-ct">
						<!-- 企业 -->
						<div class="time3">学员人数：{{item.relationOrderIds.length}}</div>
						<!-- 普通 -->
						<div class="time1">报名日期：<span>{{item.createTime}}</span></div>
					</div>
					<div class="r f-ct" v-if="item.payStatus==0">
						<div class="b1" @click="qxitm=item,hbSubmit=true,qxid=item.id">取消报名</div>
						<div class="b2" @click="link('/userCoursePay',{id:item.id})">立即缴费</div>
					</div>
					<div class="r f-ct" v-if="item.payStatus==1">
						<div class="b2" @click="link('/userOrderQYMsg',{id:item.id})">查看详情</div>
					</div>
				</div>
			</div>
		</div>
		<!-- 分页 -->
		<div class="fenye">
			<el-pagination
			background
			hide-on-single-page
			layout="prev, pager, next,jumper"
			@current-change="goPage"
			:page-size="pageSize"
			:total="total">
			</el-pagination>
		</div>
		</div>
		<!-- 弹出框 -->
		<div class="maskBg" @click="hbSubmit=false" v-if="hbSubmit"></div>
		<div class="subTips" v-if="hbSubmit">
			<el-image class="cha" @click="hbSubmit=false" :src="require('@/static/icon57.png')"></el-image>
			<el-image class="icon" :src="require('@/static/icon58.png')"></el-image>
			<div class="t1">取消报名</div>
			<div class="t2">确定取消报名培训课程【{{qxitm.courseName}}】吗</div>
			<div class="btnBox f-ct">
				<div class="b1" @click="hbSubmit=false">我再想想</div>
				<div class="b2" @click="courseOrderCancel">确定取消</div>
			</div>
		</div>
		<!-- 取消成功 -->
		<div class="maskBg" @click="hbQxScuss=false" v-if="hbQxScuss"></div>
		<div class="subTips" v-if="hbQxScuss">
			<el-image class="cha" @click="hbQxScuss=false" :src="require('@/static/icon57.png')"></el-image>
			<el-image class="icon1" :src="require('@/static/icon71.png')"></el-image>
			<div class="t3">课程取消成功</div>
		</div>
		<!-- 结束 -->
	</div>
</template>
<script>
import { courseOrderlist,
coursecategoryList,
courseOrderCancel,
courseOrderlistQY,
courseOrderorderorderCancel
} from "/src/api/api.js"
import {mapState,mapGetters,mapActions,mapMutations} from 'vuex'
export default {
	data(){
		return {
			hbSubmit:false,
			hbQxScuss:false,
			qxid:'',
			qxitm:'',
			// 筛选
			catArr:[],
			catArr1:[],
			catIdx:0,
			catIdx1:0,
			keyword:'',
			payStatusOptions: [
				{
					value: '0',
					label: '待支付'
				},
				{
					value: '1',
					label: '已支付'
				},
				{
					value: '2',
					label: '已取消'
				}
			],
			payStatusValue: '',
			// 分页
			pageNum:1,
			pageSize:10,
			total:0,
			// 列表
			orderList:[],
		}
	},
	mounted() {
		this.coursecategoryList()
		this.courseOrderlist()
	},
	methods:{
		// 取消订单 课程
		async courseOrderCancel(){
			let res;
			if(this.userType==1){
				res = await courseOrderCancel({orderId:this.qxid});
			}
			if(this.userType==2){
				res = await courseOrderorderorderCancel({companyOrderId:this.qxid});
			}
			if(res.code==200){
				this.courseOrderlist(1)
				this.hbSubmit = false
				this.hbQxScuss = true
			}else{this.Tips(res.msg,'error')}
		},
		// 选择分类
		selCat(item){
			this.catIdx = item.id
			this.catArr1 = item.childList
			this.catIdx1 = item.childList[0].id
			this.pageNum = 1
			this.courseOrderlist(1)
		},
		// 选择分类
		selCat1(id){
			this.catIdx1 = id
			this.pageNum = 1
			this.courseOrderlist(1)
		},
		// 跳转页
		goPage(e){
			this.pageNum = e
			this.courseOrderlist()
		},
		// 查询课程列表
		async courseOrderlist(def){
			let res;
			if(def){this.pageNum=1}
			var data = {
				pageSize: this.pageSize,
				pageNum: this.pageNum,
				orderByColumn: 'id',
				isAsc: 'desc',
				
			}
			if(this.catIdx1){
				data.courseCategoryId = this.catIdx1
			}
			if(this.keyword){
				data.courseName = this.keyword
			}
			// if(this.payStatusValue!=-1){
			// 	data.payStatus = this.payStatusValue
			// }
			data.payStatus = this.payStatusValue
			if(this.userType==1){
				res = await courseOrderlist(data);
			}
			if(this.userType==2){
				res = await courseOrderlistQY(data);
			}
			if(res.code==200){
				if(this.pageNum==1){
					this.total = res.total
				}
				this.orderList = res.rows
			}else{this.Tips(res.msg,'error')}
		},
		// 分类列表
		async coursecategoryList(){
			let res = await coursecategoryList({});
			if(res.code==200){
				var catIdx = []
				res.data.categoryList.forEach((item)=>{
					item.childList = [{
						id:item.id,
						categoryName:'全部',
					},...item.childList]
				})
				this.catArr = [{
					id:0,
					categoryName:'全部',
					childList:[{
						id:0,
						categoryName:'全部'
					},...res.data.allChildCategoryList],
				},...res.data.categoryList]
				this.catArr1 = this.catArr[0].childList
			}else{this.Tips(res.msg,'error')}
		},
	},
	computed:{
		...mapState('userMsg',['userInfo','userType']),
	}
}
</script>
<style lang="scss">
body{
	// background: #f6f7fb;
}
</style>
<style lang="scss" scoped>
.conBox{
	margin: 0 40px;
	background: #fff;
	border-radius: 20px;
	padding-bottom: 32px;
}
.pageTit{
	border-bottom: 1px solid #DDDDDD;
	margin: 0 24px;
	padding-top: 24px;
	padding-bottom: 14px;
	span{
		font-size: 18px;
		color: #3B6492;
		font-weight: bold;
		position: relative;
		&::after{
			content: '';
			width: 100%;
			height: 4px;
			border-radius: 4px;
			background: #3B6492;
			position: absolute;
			bottom: -14px;
			left: 0;
		}
	}
}
.shaixuan{
	// width: 100%;
	padding: 0 24px;
	// background: #fff;
	.catBox{
		padding: 24px 0;
		padding-bottom: 10px;
		// border-bottom: 1px solid #EEEEEE;
	}
	.cat{
		margin-bottom: 20px;
		&:last-child{
			margin-bottom: 0;
		}
		.tit{
			font-size: 14px;
			color: #333333;
		}
		.itm{
			margin-left: 18px;
			height: 28px;
			line-height: 28px;
			padding: 0 8px;
			border-radius: 4px;
			font-size: 14px;
			color: #545964;
			cursor: pointer;
		}
		.a{
			background: #E9F6FF;
			color: #3B6492;
			cursor: pointer;
		}
	}
	.seach{
		width: 100%;
		height: 70px;
		background: #fff;
		padding: 15px 0px;
		padding-top: 0;
		.iptBox{
			width: 1332px;
			height: 40px;
			border: 1px solid #DDDDDD;
			margin-right: 12px;
			.sel{
				.el-select{
					width: 97px;
				}
				::v-deep .el-input__inner{
					border: none;
					background: transparent;
					font-size: 14px;
				}
			}
			.bor{
				width: 1px;
				height: 20px;
				background: #DDDDDD;
			}
			.ipt{
				width: calc(100% - 100px);
				.el-select{
					width: 100%;
				}
				::v-deep .el-input__inner{
					border: none;
					background: transparent;
				}
			}
		}
		.seachBtn{
			div{
				width: 85px;
				height: 40px;
				border: 1px solid #DDDDDD;
				font-size: 16px;
				color: #666666;
				text-align: center;
				line-height: 38px;
				cursor: pointer;
				&:first-child{
					background: #3B6492;
					border: 1px solid #3B6492;
					color: #fff;
					margin-right: 12px;
				}
			}
		}
	}
}
.fenye{
	margin: 0 24px;
	display: flex;
	align-items: center;
	justify-content: flex-end;
	margin-top: 26px;
	.i1{
		width: 24px;
		height: 24px;
		margin-right: 6px;
	}
	.fyitm{
		width: 32px;
		height: 32px;
		font-size: 12px;
		text-align: center;
		line-height: 32px;
		margin-right: 6px;
		border-radius: 4px;
	}
	.a{
		background: #3B6492;
		color: #fff;
	}
	.i2{
		width: 24px;
		height: 24px;
		margin-right: 19px;
	}
	.linkPage{
		p{
			font-size: 12px;
		}
		.ipt{
			margin: 0 6px;
			width: 42px;
			height: 32px;
			border-radius: 4px;
			background: #F4F4F4;
			.el-select{
				width: 100%;
			}
			::v-deep .el-input__inner{
				border: none;
				background: transparent;
			}
		}
	}
}
.orderList{
	width: 1526px;
	margin: auto;
	.item{
		width: 100%;
		border: 1px solid #EFF1F6;
		margin-bottom: 24px;
		.osn{
			width: 100%;
			height: 60px;
			padding: 0 24px;
			border-bottom: 1px solid #EFF1F6;
			.sn{
				font-size: 14px;
				color: #9A9DA7;
			}
			.s4{
				color: #545964;
				background: #EFF1F6;
			}
			.status{
				min-width: 72px;
				height: 30px;
				line-height: 30px;
				text-align: center;
				border-radius: 4px;
				font-size: 14px;
				padding: 0 15px;
				margin-left: 16px;
			}
			.s1{
				color: #FF5F5A;
				background: #FFEAEA;
			}
			.s2{
				color: #E86F26;
				background: #FFF1DF;
			}
			.s3{
				color: #3B6492;
				background: #E1F1FF;
			}
		}
		.msg{
			padding: 0 24px;
			border-bottom: 1px solid #EFF1F6;
			.l{
				padding-top: 18px;
				padding-bottom: 18px;
				.name{
					font-size: 18px;color: #373D50;
					font-weight: bold;
				}
				.tagBox{
					.tagItm{
						min-width: 76px;
						margin-right: 11px;
						margin-top: 10px;
						height: 28px;
						padding: 0 10px;
						line-height: 26px;
						text-align: center;
						border-radius: 4px;
						font-size: 14px;
						color: #3B6492;
						border: 1px solid #3B6492;
					}
				}
			}
			.r{
				font-size: 18px;
				span{
					color: #FF5F5A;
					font-weight: bold;
				}
			}
		}
		.time{
			padding: 8px 24px;
			.l{
				.time1{
					font-size: 14px;
					color: #7D7D89;
					margin-right: 32px;
					span{
						color: #373D50;
					}
				}
				.time2{
					font-size: 14px;
					color: #FF5F5A;
				}
				.time3{
					margin-right: 32px;
					font-size: 14px;
					color: #3B6492;
				}
			}
			.r{
				justify-content: center;
				div{
					width: 148px;
					height: 44px;
					border-radius: 6px;
					text-align: center;
					line-height: 44px;
					font-size: 16px;
					cursor: pointer;
				}
				.b1{
					background: #E9F6FF;
					color: #3B6492;
				}
				.b2{
					background: #3B6492;
					color: #fff;
					margin-left: 14px;
				}
			}
		}
	}
}
.maskBg{
	position: fixed;
	width: 100%;
	height: 100%;
	top: 0;
	left: 0;
	background: rgba(0, 0, 0, 0.4);
	z-index: 10;
}
.subTips{
	position: fixed;
	width: 420px;
	// height: 364px;
	padding-bottom: 34px;
	background: #fff;
	border-radius: 8px;
	z-index: 11;
	top: 50%;
	left: 50%;
	transform: translateX(-50%)translateY(-50%);
	.cha{
		position: absolute;
		right: 20px;
		top: 20px;
		width: 14px;
		height: 14px;
	}
	.icon{
		display: block;
		margin: auto;
		margin-top: 48px;
		width: 90px;
		height: 90px;
	}
	.icon1{
		display: block;
		margin: auto;
		margin-top: 48px;
		width: 115px;
		height: 115px;
	}
	.t3{
		font-size: 18px;
		color: #2F3541;
		font-weight: 600;
		text-align: center;
		margin-top: 10px;
	}
	.t1{
		font-size: 18px;
		color: #2F3541;
		font-weight: 600;
		text-align: center;
		margin-top: 25px;
	}
	.t2{
		font-size: 14px;
		color: #7D7D89;
		padding: 0 26px;
		text-align: center;
		margin-top: 12px;
		line-height: 28px;
	}
	.btnBox{
		margin-top: 28px;
		justify-content: center;
		div{
			width: 120px;
			height: 46px;
			border-radius: 6px;
			text-align: center;
			line-height: 46px;
			font-size: 16px;
			cursor: pointer;
		}
		.b1{
			background: #E9F6FF;
			color: #3B6492;
		}
		.b2{
			background: #3B6492;
			color: #fff;
			margin-left: 14px;
		}
	}
}
</style>